import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center text-danger-500 py-6"
}
const _hoisted_9 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "text-black dark:text-white" }
const _hoisted_12 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_13 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_14 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_15 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_16 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_17 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_18 = { class: "font-medium text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tr-md" }
const _hoisted_19 = { class: "font-medium text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tr-md" }
const _hoisted_20 = { class: "text-black dark:text-white" }
const _hoisted_21 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_22 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "rounded-md w-[40px]" }
const _hoisted_25 = ["src", "onError"]
const _hoisted_26 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_27 = { class: "block font-medium" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_31 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_32 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_33 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_34 = { class: "flex items-center gap-[9px]" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  colspan: "8",
  class: "text-center py-10"
}
const _hoisted_38 = { class: "flex flex-col items-center justify-center" }
const _hoisted_39 = { class: "text-lg mb-2" }
const _hoisted_40 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_41 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
}
const _hoisted_42 = { class: "bg-white dark:bg-[#0c1427] p-6 rounded-md max-w-md w-full" }
const _hoisted_43 = { class: "text-lg font-medium mb-4" }
const _hoisted_44 = { class: "mb-6" }
const _hoisted_45 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: _ctx.directT('ecommerce.orders.searchOrder'),
              class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.searchQuery]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" }, null, -1)
            ])))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.directT('ecommerce.orders.orderId')), 1),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.directT('ecommerce.orders.customer')), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.directT('ecommerce.orders.items')), 1),
                      _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.directT('ecommerce.orders.created')), 1),
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.directT('ecommerce.orders.total')), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('ecommerce.orders.vendor')), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('ecommerce.orders.status')), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('ecommerce.orders.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrders, (order) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: order.id
                      }, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(order.orderid), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: order.customerImage,
                                class: "inline-block rounded-md",
                                alt: "customer-image",
                                onError: (e) => _ctx.handleImageError(e, order)
                              }, null, 40, _hoisted_25)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(order.name || 'Unknown Customer'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.getProductCount(order)), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatDate(order.created_at)), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatPrice(order.total)), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(order.vendor || 'N/A'), 1),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getStatusClass(order.status))
                          }, _toDisplayString(_ctx.getStatusText(order.status)), 3)
                        ]),
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                              to: `/ecommerce/order-details/${order.id}`,
                              class: "text-primary-500 leading-none custom-tooltip"
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                              ])),
                              _: 2,
                              __: [5]
                            }, 1032, ["to"])), [
                              [_directive_tooltip, _ctx.directT('ecommerce.orders.view')]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                              to: `/ecommerce/edit-order/${order.id}`,
                              class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                              ])),
                              _: 2,
                              __: [6]
                            }, 1032, ["to"])), [
                              [_directive_tooltip, _ctx.directT('ecommerce.orders.edit')]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "text-danger-500 leading-none custom-tooltip",
                              onClick: ($event: any) => (_ctx.confirmDelete(order))
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                            ]), 8, _hoisted_35)), [
                              [_directive_tooltip, _ctx.directT('ecommerce.orders.delete')]
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.filteredOrders.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                          _createElementVNode("td", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "material-symbols-outlined text-6xl text-gray-300 dark:text-gray-600 mb-4" }, "shopping_cart", -1)),
                              _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.directT('ecommerce.orders.noOrdersYet')), 1),
                              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.directT('ecommerce.orders.startByCreating')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.directT('ecommerce.orders.confirmDelete')), 1),
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.directT('ecommerce.orders.deleteWarning')), 1),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal = false)),
                class: "px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded-md"
              }, _toDisplayString(_ctx.directT('ecommerce.orders.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedOrder && _ctx.deleteSelectedOrder(...args))),
                class: "px-4 py-2 bg-danger-500 text-white rounded-md"
              }, _toDisplayString(_ctx.directT('ecommerce.orders.delete')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}